export default __webpack_public_path__ + "static/media/NEP.1720116d.svg";